export enum UrlEnum
{
    public_searchByClinicName = '/api/public/userpoolcognito/searchByClinicName',
    public_clinicSignUp = '/api/public/clinicSignUp',
    private_roles = '/api/roles',
    private_all_roles = '/api/roles/readonly',
    private_search_user_distinct_role = '/api/users/search/distinctRole',
    private_search_user_in_role = '/api/users/search/inRole',
    private_search_user = '/api/users/search/byQuery',
    private_search_detailed_user = '/api/users/search/details/byQuery',
    private_create_patient = '/api/users/patient',
    private_get_patients = '/api/users/patients?page={page}&size={size}&sortBy={sortBy}',
    private_get_patients_detailed = '/api/users/patients/details?page={page}&size={size}&sortBy={sortBy}',
    private_create_doctor = '/api/users/doctor',
    private_create_admin = '/api/users/admin',
    private_create_front_desk = '/api/users/frontdesk',
    private_create_visitor = '/api/users/visitor',
    private_user = '/api/users/{userId}',
    private_user_role = '/api/users/{userId}/role/{roleId}',
    private_add_user_profile_pic = '/api/users/profile/{userId}',
    users_in_calendar_evt = '/api/users/event/participants/{eventId}',
    private_notifications_user_ui = '/api/notifications/ui/user/{userId}',
    private_notifications = '/api/notifications/ui/{id}',
    platform_notifications = '/api/notifications/ui/platform',
    private_notifications_clear_all = '/api/notifications/ui/all/acknowledged/{userId}',
    contact_info = '/api/userContacts/{id}',
    user_contact_info = '/api/userContacts/user/{userId}',
    permission_matrix = '/api/security/permissions',
    wellcome_dashboard = '/api',
    clinic_dashboard = '/api/clinic/dashboard',
    clinic_financial_dashboard = '/api/clinic/financial',
    clinic_team_members = '/api/clinic/team',
    platform_admin = '/api/platform',
    private_event_find = '/api/events/{startDate}/{endDate}/calendar/{id}',
    private_event_find_v1 = '/api/events/v1/{startDate}/{endDate}/calendar/{id}',
    private_patient_event_find = '/api/events/v1/patients/{startDate}/{endDate}/calendar/{id}',
    private_event = '/api/events/{id}',
    private_event_response = '/api/events/{id}/response',
    private_event_create = '/api/events',
    private_event_create_with_user = '/api/events/with_new_user',
    platform_signup = 'api/clinicSignUp',
    private_cognitoOnboard= '/api/userpoolcognito',
    private_clinicSignUp = '/api/clinicSignUp',
    private_clinicSignUp_update = '/api/clinicSignUp/{Id}',
    private_masterData = '/api/masterData',
    private_masterData_tenant = '/api/masterData/tenant',
    private_masterData_stats_user_count = '/api/masterData/stats/users/count',
    private_masterData_stats_team = '/api/masterData/stats/team',
    private_masterData_stats_latest_notifications = '/api/masterData/stats/latest-notifications',
    private_masterData_stats_latest_internal_payments = '/api/masterData/stats/latest-internal-payments',
    private_masterData_stats_team_role = '/api/masterData/stats/team/{userId}/role/{roleId}',
    private_masterData_stats_app_entitlements = '/api/masterData/stats/app-entitlements',
    private_masterData_stats_app_resource = '/api/masterData/stats/app-resources/{id}',
    private_calendar_full_settings = '/api/calendarSettingss/fullcalendarsettings/{calendarId}',
    private_calendar_settings = '/api/calendarSettingss/{id}',
    private_calendar_categ_id = '/api/agendaCategories/{id}',
    private_calendar_categ = '/api/agendaCategories',
    private_calendar_working_day_hours = '/api/calendarDayWorkingHours/calendar/{calendarId}',
    private_calendar_working_day_hours_bulk_update = '/api/calendarDayWorkingHours/bulk',
    private_room ='/api/room',
    private_room_search_delete='/api/room/{roomName}',
    private_clinic='/api/clinic',
    private_clinic_update='/api/clinic/{id}',
    private_clinic_logo = '/api/clinic/logo/{clinicId}',
    private_usr_stats = '/api/userstatistics',
    private_usr_stats_trend = '/api/userstatistics/{startDate}/{endDate}',
    private_usr_stats_activity = '/api/userstatistics/activity?page={page}&size={size}&sortBy={sortBy}',
    private_clinic_treatments= '/api/treatments/clinic/{clinicId}/byDiscipline/{disciplineId}?page={page}&size={size}',
    private_treatment= '/api/treatments/{id}',
    private_treatment_post= '/api/treatments',
    private_treatment_status = '/api/treatments/status/{id}',
    private_disciplines = '/api/disciplines',
    private_clinic_conditions= '/api/conditions/clinic/{clinicId}/byDiscipline/{disciplineId}?page={page}&size={size}',
    private_condition= '/api/conditions/{id}',
    private_condition_post= '/api/conditions',
    private_condition_status = '/api/conditions/status/{id}',
    private_get_patient_from_user = '/api/users/patient/user/{userId}',
    private_get_doctor_from_user = '/api/doctorRoles/user/{userId}',

    private_mouth_status = '/api/teeth/status/{mouthId}',
    private_update_teeth_bulk = '/api/teeth/bulk',
    private_update_conditions_bulk_foreign = '/api/teeth/condition/foreign/bulk',
    private_update_conditions_bulk = '/api/teeth/condition/bulk',

    private_update_mouth_conditions_bulk_foreign = '/api/mouths/condition/foreign/bulk',
    private_update_mouth_conditions_bulk = '/api/mouths/condition/bulk',

    private_get_notes_resource = '/api/notes/all/{resourceId}',
    private_get_notes_resource_interventions = '/api/notes/all/stoma_interventions/{stomaInterventionId}',
    private_delete_note = '/api/notes/{noteId}',
    private_create_note = '/api/notes',

    private_delete_condition = '/api/teeth/condition/{toothConditionId}',
    private_delete_mouth_condition = '/api/mouths/condition/{mouthConditionId}',
    private_update_condition_status = '/api/teeth/condition/status/{conditionId}',

    private_get_all_user_warns = '/api/userwarnings/all/{userId}',
    private_get_all_patient_medical_warns = '/api/medicalwarnings/all/{patientId}',
    private_post_user_warning = '/api/userwarnings',
    private_put_user_warning = '/api/userwarnings/{id}',

    private_post_user_medical_warning = '/api/medicalwarnings',
    private_user_medical_warning = '/api/medicalwarnings/{id}',

   private_get_user_interventions = '/api/stoma-interventions/patient/{patientId}',
   private_get_intervention_statistics = '/api/stoma-interventions/statistics',
   private_post_user_interventions = '/api/stoma-interventions',
   private_post_clone_intervention = '/api/stoma-interventions/clone/{id}',
   private_put_user_interventions = '/api/stoma-interventions/{id}',
   private_delete_intervention = '/api/stoma-interventions/{id}',
   private_put_intervention_status = '/api/stoma-interventions/{id}/to-state?interventionState={status}',
   private_add_treatments_in_interventions_bulk = '/api/stoma-interventions/treatments/{treatmentId}/bulk',
   private_interventions_state_bulk_change = '/api/stoma-interventions/bulk/to-state?interventionState={status}',
   private_interventions_to_payment = '/api/stoma-interventions/{id}/invoice-entries',


   private_post_add_treatment_to_intervention = '/api/stoma-interventions/{id}/treatments',
   private_link_calendar_event_to_intervention = '/api/stoma-interventions/{id}/events',
   private_link_calendar_events_to_interventions_bulk = '/api/stoma-interventions/bulk/events',


   private_get_medic_agenda =   '/api/doctorRoles/activities/{doctorCalendarId}/{targetDate}',
   private_get_medic_agenda_V2 =   '/api/doctorRoles/activities_v2/{doctorCalendarId}/{targetDate}',
   private_get_clinic_consumption = '/api/clinic/consumption',

   private_user_notification_settings = '/api/notificationSettings/{id}',

   private_medical_instrument = '/api/instruments',
   private_medical_instrument_all = '/api/instruments/all',
   private_medical_instrument_update = '/api/instruments/{id}',

   private_sterilization_device =  '/api/sterilization_devices',
   private_sterilization_device_all = '/api/sterilization_devices/all',
   private_sterilization_device_update = '/api/sterilization_devices/{id}',

   private_sterilization_cycle = "/api/sterilization_cycles",
   private_sterilization_cycle_get = "/api/sterilization_cycles/{id}",
   private_sterilization_cycle_add_instrument_bulk = "/api/sterilization_cycles/{id}/sterilization_cycle_instruments/bulk",
   private_sterilization_cycle_all = "/api/sterilization_cycles/all?page={page}&size={size}&sortBy={sortBy}",
   private_sterilization_instruments_by_status = "/api/sterilization_cycle_instruments/by_status?used={used}",
   private_event_linked_sterilization_instruments = "/api/sterilization_cycle_instruments/event/{eventId}",
   private_event_link_sterilization_instruments_bulk = "/api/sterilization_cycle_instruments/event/{eventId}/bulk",
   private_sterilization_instruments_update_compromised = "/api/sterilization_cycle_instruments/{id}/compliant",


   private_room_availability = "/api/events/availabilities/{startDate}/{endDate}",
   private_doctors_performance = "/api/userstatistics/doctors/performance/{startDate}/{endDate}",

   private_legal_smm_docs_get_all = "/api/legal-documents",


   private_docs_get_all = "/api/user-warnings/all/{userId}",
   private_docs_get = "/api/user-warnings/{id}",

   private_docs_flows_get_all = "/api/user-warnings-audits/users/{userId}",
   private_docs_flows_get = "/api/user-warnings-audits/{id}",
   private_docs_flows_trigger = "/api/user-warnings-audits",
   private_docs_flows_trigger_bulk = "/api/user-warnings-audits/bulk",
   private_docs_flows_cancel = "/api/user-warnings-audits/{id}/cancel",
   private_all_user_fields_by_patient_key = "/api/user-input-fields/by-userkey?userKey={usrKey}",
   private_all_user_fields_by_docID = "/api/user-input-fields/user-warnings/{userWarningId}",
   private_create_user_field_bulk = "/api/user-input-fields/user-warnings/{userWarningId}/bulk",
   private_update_user_field_bulk = "/api/user-input-fields/bulk",

   private_update_doc_flow_status = "/api/user-warnings-audits/{id}/to-status?nextStatus={nextStatus}",
   private_update_doc_notification = "/api/user-warnings-audits/{id}",

   private_doc_get_by_userKey_and_status = "/api/user-warnings/user-key/{userKey}/by-status?userWarningAuditStatus={status}",
   private_doc_flow_get_by_userKey_and_status = "/api/user-warnings-audits/user-key/{userKey}/by-status?userWarningAuditStatus={status}",
   private_doc_update_signature = "/api/user-warnings/{id}/signature",

    private_sterilization_device_journal = "/api/sterilization_devices/journal_logs",
    private_get_sterilization_device_journal = "/api/sterilization_devices/journal_logs/{sterilizationDevicesId}",

    private_get_app_module = '/api/app-modules',
    private_update_app_module = '/api/app-modules/{id}/subscription?value={value}',

    private_cart_get = '/api/orders/active',
    private_cart_add = '/api/products',
    private_cart_delete = '/api/products/{id}',
    private_cart_update = '/api/products/{id}/{count}',
    private_cart_checkout = '/api/netopia/payment/{orderId}',
    private_cart_cancel = '/api/netopia/payment/cancel/{orderId}',

    private_get_app_resource = '/api/app-resources',

    private_person_billing_info='/api/personal-billings',
    private_person_billing_info_edit='/api/personal-billings/{id}',

    private_company_billing_info='/api/company-billings',
    private_company_billing_info_edit='/api/company-billings/{id}',

    private_order_history='/api/orders/history',
    private_order_history_details='/api/products/orders/{orderId}',

    private_get_all_patient_treatment_plan = '/api/treatment-plans/patients/{patientId}',
    private_store_patient_treatment_plan = '/api/treatment-plans',
    private_update_patient_treatment_plan = '/api/treatment-plans/{id}',

    private_create_treatment_plan_stage = '/api/treatment-plans/{treatmentPlanId}/stages',
    private_update_treatment_plan_stage = '/api/treatment-plans/{treatmentPlanId}/stages/{stageId}',
    private_update_bulk_pos_treatment_stage = '/api/treatment-plans/{treatmentPlanId}/stages/order',
    private_link_intervention_in_plan_stage = '/api/treatment-plans/{treatmentPlanId}/stages/{stageId}/stoma-interventions',
    private_link_intervention_swap = '/api/treatment-plans/{treatmentPlanId}/stages/{fromStageId}/stoma-interventions/{interventionId}/move-to/{toStageId}',
    private_clone_treatment_plan = '/api/treatment-plans/{id}/clone',
    private_treatment_plan_send_email = '/api/treatment-plans/send-email',

    private_plan_pricing = '/api/treatment-plan-pricing/{treatmentPlanId}',
    private_plan_pricing_item_custom = '/api/treatment-plan-pricing-item/{itemId}/custom-price',
    private_plan_pricing_custom = '/api/treatment-plan-pricing/{treatmentPlanId}/discount',
    private_documents_presigned_url= '/api/documents/presigned_url',
    private_documents_status = '/api/documents/{documentId}',
    private_documents_status_bulk = '/api/documents/bulk',
    private_documents_all = '/api/documents/{userId}',
    private_documents_download_url = '/api/documents/presigned_url/{documentId}',

    private_recalls = '/api/recalls',
    private_recall = '/api/recalls/{id}',
    private_recall_template = '/api/recalls/{id}/notifications',
    private_recall_template_get = '/api/recalls/{id}/notifications?notificationType={notificationType}',
    private_recalls_status_based = '/api/recalls/status',
    private_recalls_by_user = '/api/recalls/user/{userId}',

    //Invoice Entry Resource
    private_invoice_entry_get_patient = '/api/clinic-finance/invoice-entries/unattached?page={page}&size={size}&chargedUserId={chargedUserId}',
    private_invoice_entry = '/api/clinic-finance/invoice-entries',
    private_invoice_entry_create_from_treatments = '/api/clinic-finance/invoice-entries/from-treatments',
    private_invoice_entry_update = '/api/clinic-finance/invoice-entries/{id}',
    private_invoice_discount = '/api/clinic-finance/invoice-entries/discount',
    private_invoice_entry_clone = '/api/clinic-finance/invoice-entries/{id}/clone',

    // Invoice resource
    private_invoice_get_patient = '/api/clinic-finance/invoices/patient/{userId}?page={page}&size={size}',
    private_invoice_search = '/api/clinic-finance/invoices/search',
    private_invoice_create_from_entries = '/api/clinic-finance/invoices/with-entries',
    private_invoice_checkout = '/api/clinic-finance/invoices/checkout',
    private_get_invoice_related_transactions = '/api/clinic-finance/invoices/{id}/transactions',
    private_get_invoice = '/api/clinic-finance/invoices/{id}',
    private_pay_invoice = '/api/clinic-finance/invoices/{invoiceId}/pay',

    // User account resource
    private_user_account_get = '/api/clinic-finance/accounts/{userId}',
    private_user_account_get_transactions = '/api/clinic-finance/accounts/{userId}/transactions/query',
    private_user_account_credit = '/api/clinic-finance/accounts/{userId}/credit',
    private_user_account_distribute_balance = '/api/clinic-finance/accounts/{userId}/distribute-balance',

    private_appointment_confirm_get = '/api/public/event/{token}',
    private_appointment_confirm = '/api/public/event/{token}/confirm',
    private_appointment_decline = '/api/public/event/{token}/decline?reason={reason}',

    private_holidays = '/api/events/non-visit',


}
